import { denormalize, normalize, schema } from "normalizr";

export const normalizeEntity = (datasources) => {
	const isArray = datasources instanceof Array;
	const dataset = isArray ? "customerCategories" : "customerCategory";
	const customerCategoryEntity = new schema.Entity(dataset);
	const result = normalize(
		datasources, 
		isArray ? [customerCategoryEntity] : customerCategoryEntity
	);
	
	return result.entities;
}

export const denormalizeEntity = (datasources) => {
	const isArray = datasources.customerCategories;
	const dataset = isArray ? "customerCategories" : "customerCategory";
	const customerCategoryEntity = new schema.Entity(dataset)
	const entities = isArray ? datasources.customerCategories : datasources.customerCategory;

	return denormalize(
		{ [dataset]: isArray ? Object.keys(entities) : Object.keys(entities).toString() }, 
		{ [dataset]: isArray ? [customerCategoryEntity] : customerCategoryEntity }, 
		{ [dataset]: entities }
	);
}